var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.346,
    height: 22.404,
    viewBox: "0 0 20.346 22.404",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "print",
    transform: "translate(-1258.018 -76.489)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1527",
    "data-name": "Rectangle 1527",
    width: 19.612,
    height: 5.579,
    transform: "translate(1258.397 93.314)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3470",
    "data-name": "Path 3470",
    d: "M1273.792,88.855V76.843h-11.2V88.855",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.709
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3637",
    "data-name": "Group 3637"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3471",
    "data-name": "Path 3471",
    d: "M1265.971,82.88l1.889,1.685,3.058-3.74",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.709
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3472",
    "data-name": "Path 3472",
    d: "M1262.589,85.744h-2.531a.523.523,0,0,0-.514.431l-1.162,6.526a.521.521,0,0,0,.513.613h18.591A.522.522,0,0,0,1278,92.7l-1.163-6.526a.521.521,0,0,0-.513-.431h-2.532",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.709
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3473",
    "data-name": "Path 3473",
    d: "M1275.065,87.944l.356,2.782h-14.46l.356-2.782",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.709
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1295",
    "data-name": "Line 1295",
    y2: 5.761,
    transform: "translate(1258.397 92.945)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.709
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1296",
    "data-name": "Line 1296",
    y2: 5.761,
    transform: "translate(1278.008 92.945)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.709
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.b89ed5082270d402990f1e137dc0c7f4.svg";
export { ForwardRef as ReactComponent };